import React from 'react';

import { AccordionItemId, OpenSections } from '../models';

interface AccordionHeaderProps {
  onToggled: (index: AccordionItemId) => void;
  itemId: AccordionItemId;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  openSections: OpenSections;
}

class AccordionHeader extends React.PureComponent<AccordionHeaderProps> {
  componentDidMount() {
    const { defaultOpen = false, onToggled, itemId } = this.props;

    if (defaultOpen) {
      onToggled(itemId);
    }
  }

  render() {
    const { itemId, onToggled, openSections, className= '', children } = this.props;

    const isOpen = !!openSections[itemId];

    const accessibilityAttr: React.HTMLAttributes<HTMLButtonElement> = {
      'id': `accordion__body__header__${`${itemId}`}`,
      'aria-controls': `accordion__header-${`${itemId}`}`,
      'aria-expanded': isOpen,
      'aria-describedby': `accordion__describeby__header-${`${itemId}`}`,
    };

    return (
      // tslint:disable-next-line jsx-no-lambda
      <button {...accessibilityAttr} className={className || ''} onClick={() => onToggled(itemId)}>
        {children}
      </button>
    );
  }
}

export { AccordionHeaderProps, AccordionHeader } ;
